import { FaCheck, FaTimes } from "react-icons/fa";
import { Modal } from "reactstrap";
import Cropper from "react-cropper";
import { useState, useRef } from 'react';
import { FiUploadCloud } from "react-icons/fi";
import "cropperjs/dist/cropper.css";


const ImageCropper = ({ imageSelectModal, setImageSelectModal, apply }) => {
    const cropperRef = useRef(null);
    const inputRef = useRef(null);
    const [defaultFile, setDefaultFile] = useState("");
    // const [file, setFile] = useState("");


    const handleCropChange = () => {
        const croppedImgData = cropperRef.current.cropper
            .getCroppedCanvas()
            .toDataURL();
        apply(croppedImgData);
        setDefaultFile("");
    }

    return (
        <Modal centered isOpen={imageSelectModal} className="px-3">
            <div onClick={() => { setImageSelectModal(false) }} className='position-absolute cursor-pointer' style={{ top: 6, right: 10 }}>
                <FaTimes size={20} />
            </div>

            <div className="px-0 pt-5 pb-2">
                <div className="d-flex mb-1">
                    <input ref={inputRef} id="upload-image" multiple={false} type="file" accept="image/png, image/jpeg" className="form-control col" onChange={e => {
                        // setFile(e.target.files[0]);
                        setDefaultFile(URL.createObjectURL(e.target.files[0]));
                    }} />
                    <button onClick={() => { setDefaultFile(""); inputRef.current.value = null; }} className="btn btn-danger"><FaTimes /></button>
                    <button onClick={handleCropChange} className="btn btn-success"><FaCheck /></button>
                </div>
                {defaultFile ?
                    <Cropper
                        ref={cropperRef}
                        src={defaultFile}
                        aspectRatio={1}
                        viewMode={1}
                        minCropBoxHeight={10}
                        minCropBoxWidth={10}
                        background={false}
                        responsive={true}
                        autoCropArea={1}
                        checkOrientation={false}
                        guides={true}

                    />
                    :
                    <div style={{ position: "relative" }}>
                        <img alt="logo" style={{ aspectRatio: 1, width: "90%" }} src="/assets/images/logo.png" />
                        <div onClick={() => { inputRef.current.click(); }} className="d-flex flex-column cursor-pointer flex-wrap justify-content-center align-items-center" style={{ position: "absolute", top: 0, left: 0, height: "100%", width: "100%", background: "#00000090" }}>
                            <FiUploadCloud color="#ffffff" size={80} />
                            <p className="text-white">Upload Image</p>
                        </div>

                    </div>
                }
            </div>
        </Modal>
    );
}

export default ImageCropper;